import { useParams } from 'react-router';
import ReadAllArticles from './common/ReadAllArticles.react';
import ArticleBreadcrumbs from './common/ArticleBreadcrumbs.react';
import ArticleTitle from './common/ArticleTitle.react';
import ArticleSubtitle from './common/ArticleSubtitle.react';
import ArticleHero from './common/ArticleHero.react';
import ArticleContacts from './common/ArticleContacts.react';
var DefaultArticle = function DefaultArticle(_ref) {
  var article = _ref.article;
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  var slug = article.slug;
  return /*#__PURE__*/React.createElement("section", {
    className: "a",
    id: "article-".concat(slug)
  }, /*#__PURE__*/React.createElement(ArticleHero, article), /*#__PURE__*/React.createElement("div", {
    className: "a__body ".concat(articleID ? 'a__body--wide' : '')
  }, /*#__PURE__*/React.createElement(ArticleBreadcrumbs, article), /*#__PURE__*/React.createElement(ArticleTitle, article), /*#__PURE__*/React.createElement(ArticleSubtitle, article), /*#__PURE__*/React.createElement(ArticleContacts, article), /*#__PURE__*/React.createElement(ReadAllArticles, {
    title: "Articles"
  })));
};
export default DefaultArticle;